import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { changeProfileLanguage } from 'cloudFunctions'
import { Text } from 'components/Ui-Kits/Text'
import { useQuery } from 'hooks/query/useQuery'
import { useProfile } from 'hooks/useProfile'
import { useAppTranslation } from 'i18n/hooks'
import { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useClickOutside } from 'hooks/useClickOutside'
import { Icon, ListItem, SubListItem } from '../Navigation.styled'

export const LanguageSwitcher = () => {
  const { i18n } = useAppTranslation()
  const { profile } = useProfile()
  const { lang } = useQuery()
  const languageWasChanged = useRef(false)
  const [show, setShow] = useState(false)
  const menuRef = useRef(null)
  useClickOutside(menuRef, show, () => setShow(false))

  useEffect(() => {
    if (lang && ['en', 'fi', 'sv'].includes(lang)) {
      i18n.changeLanguage(lang)
    }
  }, [lang, i18n])

  useEffect(() => {
    if (!profile?.language || i18n.language === profile.language || languageWasChanged.current) return

    i18n.changeLanguage(profile.language)
  }, [profile, i18n])

  const handleLanguageChange = language => {
    i18n.changeLanguage(language)
    languageWasChanged.current = true
    setShow(false)

    if (profile) changeProfileLanguage(language)
  }

  const languageItems = ['fi', 'en', 'sv'].map(language => (
    <SubListItem key={language}>
      <Text as="button" onClick={() => handleLanguageChange(language)} cursor="pointer">
        {language.toLocaleUpperCase()}
      </Text>
    </SubListItem>
  ))

  return (
    <StyledListItem ref={menuRef}>
      <Text cursor="pointer" onClick={() => setShow(s => !s)}>
        {i18n.language}
        <Icon icon={faChevronDown} />
      </Text>
      <LanguageMenu show={show}>{languageItems}</LanguageMenu>
      <InlineLanguages>{languageItems}</InlineLanguages>
    </StyledListItem>
  )
}

const LanguageMenu = styled.ul`
  display: none;
  list-style: none;
  padding: 0.75rem 0;
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  z-index: 101;
  white-space: nowrap;
  background-color: var(--color-white);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-top: 0.5rem solid var(--color-white);

  ${SubListItem} > ${Text} {
    padding: 0.5rem 1.25rem;
  }

  @media (min-width: 1024px) {
    display: ${({ show }) => (show ? 'block' : 'none')};
  }
`

const InlineLanguages = styled.ul`
  display: flex;
  flex-direction: row;
  width: auto;
  list-style: none;
  padding: 0;

  & > ${SubListItem} {
    margin: 0 0.5rem;
    & ${Text} {
      padding: 0;
    }
  }

  @media (min-width: 1024px) {
    display: none;
  }
`

const StyledListItem = styled(ListItem)`
  display: block !important;

  & > ${Text} {
    display: none;
  }

  @media (min-width: 1024px) {
    position: relative;

    & > ${Text} {
      display: inline;
    }
  }
`
